import RestClient from "@/api/utils/baseRestClient";
import { atmoClient } from "@/setup/clients/atmoClient";
import _ from "lodash";

class InstallationRestClient extends RestClient {
  handleSpecialSnakeCase(data) {
    const mapping = {
      o_2_expected_content: "O2_expected_content",
      co_2_expected_content: "CO2_expected_content",
      h_2_o_expected_content: "H2O_expected_content",
    };
    return _.mapKeys(data, (value, key) => _.get(mapping, key, key));
  }
  handleSpecialCamelCase(data) {
    const mapping = {
      h2OExpectedContent: "h2oExpectedContent",
    };
    return _.mapKeys(data, (value, key) => _.get(mapping, key, key));
  }
  async create(form, config) {
    if (!form.resultsExpression) form.resultsExpression = "GAZ_SEC";
    return await super.create(form, config);
  }
}

export const installationRestClient = new InstallationRestClient(
  atmoClient,
  "installations"
);
